import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" }) : "";

export const BlogCard = ({ article }) => (
  <Link
    to={`/blog/${article.slug}`}
    data-testid={`blog-card-${article.slug}`}
    onClick={() => window.scrollTo({ top: 0 })}
    className="group flex flex-col border border-black/10 bg-white hover:shadow-[0_8px_40px_rgba(0,0,0,0.06)] transition-shadow duration-500"
  >
    <div className="relative overflow-hidden aspect-[3/2] bg-muted">
      {article.cover_image ? (
        <img
          src={article.cover_image}
          alt={article.cover_alt || article.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-neutral-100 to-neutral-200" />
      )}
      <span className="absolute top-4 left-4 bg-white/90 backdrop-blur-md text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
        {article.category}
      </span>
    </div>
    <div className="p-6 flex flex-col flex-1">
      <h3 className="font-serif text-xl leading-snug tracking-tight group-hover:text-champagne transition-colors duration-300">
        {article.title}
      </h3>
      <p className="text-sm text-foreground/60 font-light mt-3 line-clamp-3 flex-1">{article.excerpt}</p>
      <div className="flex items-center gap-4 mt-5 text-xs text-foreground/50">
        <span>{fmtDate(article.published_at)}</span>
        <span className="flex items-center gap-1">
          <Clock strokeWidth={1.2} className="w-3.5 h-3.5" /> {article.reading_time} min
        </span>
      </div>
    </div>
  </Link>
);
